import { html,when } from '@genesislcap/web-core';
import { LandingPage } from './landing';
import bofaLogo from '../assets/bofa.svg';

export const landingTemplate = html<LandingPage>`
  <div class="landing-container">
    <div class="landing-top-header">
      <div class="header-logo-section">
        <img src="${bofaLogo}" alt="Bank of America" class="header-logo" />
        <div class="header-text">
          <span class="header-bank-name">BANK OF AMERICA</span>
          <span class="header-portal-name">Municipal Bonds</span>
        </div>
      </div>
    </div>

    <div class="landing-header">
      Welcome to the Municipal Bonds Institutional Trading Portal
    </div>

    <div class="landing-cards">
      <div class="landing-card ${x => !x.isPBIEnabled() ? 'card-disabled' : ''}" @click="${x => x.isPBIEnabled() && x.navigateToPBI()}">
        <div class="card-module-label">
          <rapid-icon name="building-columns" size="xl"></rapid-icon>
        </div>
        <h3 class="card-title">New Issues</h3>
        <p class="card-description">
          Primary market offerings
        </p>
        <div class="card-image-placeholder">
          <img alt="Open New Issues" src="landing-images/handshake_cropped.jpeg" />
        </div>
        <rapid-button appearance="accent" class="card-button" ?disabled="${x => !x.isPBIEnabled()}">
          Open New Issues
          <rapid-icon name="arrow-right" slot="end"></rapid-icon>
        </rapid-button>
      </div>
  
      <div class="landing-card ${x => !x.isMBMEnabled() ? 'card-disabled' : ''}" @click="${x => x.isMBMEnabled() && x.navigateToMBM()}">
        <div class="card-module-label">
          <rapid-icon name="water" size="xl"></rapid-icon>
        </div>
        <h3 class="card-title">Liquidity Hub</h3>
        <p class="card-description">
          Secondary market liquidity
        </p>
        <div class="card-image-placeholder">
          <img alt="Open Liquidity Hub" src="landing-images/AdobeStock_1115102947.jpeg" />
        </div>
        <rapid-button appearance="accent" class="card-button" ?disabled="${x => !x.isMBMEnabled()}">
          Open Liquidity Hub
          <rapid-icon name="arrow-right" slot="end"></rapid-icon>
        </rapid-button>
      </div>

      ${when(
        x => x.isUserManagementEnabled(),
        html<LandingPage>`
          <div class="landing-card" @click="${x => x.navigateToUserManagement()}">
            <div class="card-module-label">
              <rapid-icon name="cog" size="xxl"></rapid-icon>
            </div>
            <h3 class="card-title">User Management</h3>
            <p class="card-description">
              Configure users
            </p>
            <div class="card-image-placeholder">
              <img alt="Open New Issues" src="landing-images/investor_profiles_cropped.jpeg" />
            </div>
            <rapid-button appearance="accent" class="card-button" ?disabled="${x => !x.isUserManagementEnabled()}">
              Open User Management
              <rapid-icon name="arrow-right" slot="end"></rapid-icon>
            </rapid-button>
          </div>
        `,
      )}
    </div>
  </div>
`;

